import { render, staticRenderFns } from "./NavigationLink.vue?vue&type=template&id=4acb81aa&scoped=true"
import script from "./NavigationLink.vue?vue&type=script&lang=js"
export * from "./NavigationLink.vue?vue&type=script&lang=js"
import style0 from "./NavigationLink.vue?vue&type=style&index=0&id=4acb81aa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acb81aa",
  null
  
)

export default component.exports